import {configureStore} from "@reduxjs/toolkit";
import {
  storiesApi,
  bannersApi,
  geoApi,
  eventsApi,
  sessionApi,
  usersApi,
  couponsApi,
  billingApi,
  nuveiApi,
  wompiApi,
  followApi,
  raffleApi,
} from "./api";

export const store = configureStore({
  reducer: {
    [storiesApi.reducerPath]: storiesApi.reducer,
    [bannersApi.reducerPath]: bannersApi.reducer,
    [geoApi.reducerPath]: geoApi.reducer,
    [eventsApi.reducerPath]: eventsApi.reducer,
    [sessionApi.reducerPath]: sessionApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [couponsApi.reducerPath]: couponsApi.reducer,
    [billingApi.reducerPath]: billingApi.reducer,
    [nuveiApi.reducerPath]: nuveiApi.reducer,
    [wompiApi.reducerPath]: wompiApi.reducer,
    [followApi.reducerPath]: followApi.reducer,
    [raffleApi.reducerPath]: raffleApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(storiesApi.middleware)
      .concat(bannersApi.middleware)
      .concat(geoApi.middleware)
      .concat(eventsApi.middleware)
      .concat(sessionApi.middleware)
      .concat(usersApi.middleware)
      .concat(couponsApi.middleware)
      .concat(billingApi.middleware)
      .concat(nuveiApi.middleware)
      .concat(wompiApi.middleware)
      .concat(followApi.middleware)
      .concat(raffleApi.middleware),
});
